import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../cimento-operasyonu/Navbar.css';

export default function Navbar({ logout, onNew }) {
  const [open, setOpen] = useState(false);
  const menu = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const close = event => { if (!menu.current?.contains(event.target) || event.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', close);
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', close); };
  }, []);
  const go = id => { document.getElementById(id)?.scrollIntoView?.({ behavior: 'smooth', block: 'start' }); setOpen(false); };
  return <nav ref={menu} className="navbar common-navbar" aria-label="Ortak Parametreler menüsü">
    <Link to="/ortak-parametreler" className="navbar-left"><img src="/logo.png" alt="İnosel" className="navbar-logo" /><span className="navbar-title">Ortak Parametreler</span></Link>
    <button type="button" className="hamburger" aria-label="Menüyü aç" aria-expanded={open} aria-controls="common-navbar-links" onClick={() => setOpen(!open)}><span /><span /><span /></button>
    <div id="common-navbar-links" className={`navbar-links ${open ? 'show' : ''}`}>
      <button type="button" className="navbar-link" onClick={() => go('common-facilities')}>Tesis Yönetimi</button>
      <button type="button" className="navbar-link" onClick={() => { onNew(); go('common-facility-form'); }}>Yeni Tesis</button>
      <button type="button" className="navbar-link" onClick={() => go('common-facility-history')}>Değişiklik Geçmişi</button>
      <Link className="navbar-link" to="/secilen-proje">🔁 Proje Seç</Link>
      <button type="button" className="logout-button" onClick={async () => { await logout(); navigate('/'); }}>Çıkış</button>
    </div>
  </nav>;
}
